module.exports = __webpack_public_path__ + "img/button-upload.18770a40.svg";